import { faSave, faUndo } from '@fortawesome/free-solid-svg-icons';
import React, { useState, useEffect } from 'react'
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import { createCurrency } from '../../../helpers/api/coins';
import { SUCCESS_RESPONSE } from '../../../helpers/codeResponses/codes';
import handleErrorMessage from '../../../helpers/errors/handleErrorMessage';
import { updateCurrency } from '../../../helpers/api/currency';
import Flex from '../../common/Flex';
import ButtonIcon from '../../common/ButtonIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { Toast } from '../../UI/toast/Toast';
/* import { createCurrency, updateCurrency } from '../../../../helpers/api/currency';
import ButtonIcon from '../../../common/ButtonIcon';
import Flex from '../../../common/Flex';
import { SUCCESS_RESPONSE } from '../../../../helpers/codeResponses/codes';
import { Toast } from '../../../UI/toast/Toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import handleErrorMessage from '../../../../helpers/errors/handleErrorMessage'; */

const CreateCurrencyModal = ({ isOpen, setIsOpen, currency = { name: '', iso: '', id: null }, mutate = () => { } }) => {

    const toggle = () => setIsOpen(!isOpen);

    const [name, setName] = useState('');
    const [iso, setIso] = useState('');
    const { selectedCondominium } = useSelector((state) => state.condominium);

    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (currency?.id) {
            setName(currency?.name);
            setIso(currency?.iso);
        }
    }, [currency])

    const closeBtn = <>
        <Button className="close font-weight-normal bg-transparent border-0 shadow-none" onClick={toggle}>
            &times;
        </Button>
    </>

const save = () => {
    if (name && iso && !currency?.id) {
        setSubmitting(true);
        console.log('Creating currency...');
        createCurrency({ currency: { name, iso, condominium_id: selectedCondominium } })
            .then(({ code }) => {
                console.log('Create currency response:', code);
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({ type: 'success', title: 'Moneda creada exitosamente.' });
                    mutate();
                    toggle();
                    setName('');
                    setIso('');
                }
            })
            .catch(error => {
                console.log('Create currency error:', error);
                handleErrorMessage(error);
            })
            .finally(() => setSubmitting(false));
    }
    if (currency?.id && name && iso) {
        setSubmitting(true);
        console.log('Updating currency...');
        updateCurrency({ currency: { name, iso , condominium_id: selectedCondominium }, id: currency.id })
            .then(({ code }) => {
                console.log('Update currency response:', code);
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({ type: 'success', title: 'Moneda actualizada exitosamente.' });
                    mutate();
                    toggle();
                    setName('');
                    setIso('');
                }
            })
            .catch(error => {
                console.log('Update currency error:', error);
                handleErrorMessage(error);
            })
            .finally(() => setSubmitting(false));
    }
    if (!name || !iso) {
        Toast.fire({ type: 'error', title: 'Debe completar todos los campos.' });
    }
}

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered modalClassName="theme-modal">
            <form>
                <ModalHeader toggle={toggle} tag="div" className="px-card bg-light border-0 flex-between-center" close={closeBtn}>
                    <h5 className='mb-0'>{currency ? 'Edición de moneda' : 'Registro de moneda'}</h5>
                </ModalHeader>
                <ModalBody>
                    <Row form>
                        <Col tag={FormGroup}>
                            <Label>Nombre de la moneda</Label>
                            <Input type='text' value={name} placeholder="Ingrese el nombre de la moneda, Ej: Dolar américano" onChange={({ target }) => setName(target.value)} />
                            {name && name.length < 3 && <span className='text-danger mt-2 fs--1'>El nombre de la moneda debe tener al menos 3 carácteres.</span>}
                        </Col>
                    </Row>
                    <Row form>
                        <Col tag={FormGroup}>
                            <Label>Simbolo de la moneda</Label>
                            <Input type='text' value={iso} placeholder="Ingrese el simbolo de la moneda, Ej: $" onChange={({ target }) => setIso(target.value)} />
                            {iso && iso.length > 10 && <span className='text-danger mt-2 fs--1'>El simbolo de la moneda debe tener menos de 10 carácteres.</span>}
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Flex align='center' justify='end'>
                        <ButtonIcon icon={faUndo} onClick={toggle} color='falcon-default' size='md' className='px-5 mr-2' transform="down-1 shrink-4" ><span>Volver</span></ButtonIcon>
                        <Button color='primary' onClick={save} size='md' disabled={submitting || !name || !iso || name.length < 3 || iso.length > 10} className='px-5 mr-2' transform="down-1 shrink-4" >
                            {!submitting ? <FontAwesomeIcon icon={faSave} className='mr-2' /> : <Spinner size='sm' className='mr-2' />}
                            {!currency?.id ? <span>Registrar moneda</span> : <span>Actualizar moneda</span>}
                        </Button>
                    </Flex>
                </ModalFooter>
            </form>
        </Modal>
    )
}

export default CreateCurrencyModal;